import React from "react";
import cx from "classnames";
import { StaticImage } from "gatsby-plugin-image";
import { useMediaQuery } from "@react-hookz/web";

export const SpaceShip = () => {
	const handleScrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
	const shouldChangeLayout = useMediaQuery("(min-width: 1298px)");

	return (
		<button
			className={cx(
				"hidden outline-none justify-center group fixed bottom-4 right-0 z-10 pb-4 w-[234px] h-[136px]",
				{ "lg:flex": shouldChangeLayout },
			)}
			onClick={handleScrollTop}
		>
			<StaticImage
				src="../images/space-ship-up.png"
				alt=""
				layout="fixed"
				width={179}
				height={177}
				className="!absolute bottom-0 left-1/2 -translate-x-1/2"
			/>
		</button>
	);
};
